import { render, staticRenderFns } from "./checkBox.vue?vue&type=template&id=5ecb96c3"
import script from "./checkBox.vue?vue&type=script&setup=true&lang=js"
export * from "./checkBox.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports